import React, { useEffect, useState } from 'react';
import { api } from '../App';
import ExportBar from '../components/ExportBar';

// Normalize human-readable values to Title Case so the UI renders consistently
// regardless of how the ERP stored them (UPPERCASE / Proper Case / mixed).
// Leaves part-codes (alphanumeric with digits, no spaces, len>6) alone.
function titleCase(s) {
  if (!s) return s;
  const str = String(s);
  if (!/\s/.test(str) && /[0-9]/.test(str) && str.length > 6) return str;
  return str.toLowerCase().replace(/\b[a-z]/g, c => c.toUpperCase());
}

export default function Leaderboard({ user }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('/stages/leaderboard').then(d => { setData(Array.isArray(d) ? d : []); setLoading(false); });
  }, []);

  const medals = ['🥇', '🥈', '🥉'];
  const myRow = data.find(d => d.user_name === user.name);

  if (loading) return <div className="loading">LOADING RANKINGS...</div>;

  return (
    <div className="screen">
      <div className="header">
        <div><div className="header-logo">RISHAB</div><div className="header-sub">This Week's Rankings</div></div>
        {myRow && (
          <div className="xp-badge">⚡ {myRow.weekly_xp} XP</div>
        )}
      </div>
      <ExportBar reportKey="leaderboard" title="This Week's Rankings" sections={[{ name: 'Rankings', columns: [{ key: 'rank', label: '#', type: 'int' }, { key: 'user_name', label: 'User' }, { key: 'weekly_xp', label: 'Weekly XP', type: 'int', total: true }, { key: 'updates_this_week', label: 'Updates', type: 'int', total: true }, { key: 'current_streak', label: 'Streak', type: 'int' }], rows: (data || []).map((r, i) => ({ rank: i + 1, ...r })) }]} source={{ endpoint: '/stages/leaderboard' }} />

      {/* My stats */}
      {myRow && (
        <div className="card" style={{ margin: '16px 16px 8px', background: 'rgba(201,168,76,0.05)', borderColor: 'rgba(201,168,76,0.3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 22 }}>You · Rank #{myRow.rank}</div>
              <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 4 }}>
                🔥 {myRow.current_streak} day streak · Best: {myRow.longest_streak} days
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 36, color: 'var(--gold)' }}>{myRow.weekly_xp}</div>
              <div style={{ fontSize: 9, color: 'var(--text3)', letterSpacing: 2 }}>XP THIS WEEK</div>
            </div>
          </div>
          <div style={{ marginTop: 12, fontSize: 12, color: 'var(--text3)' }}>
            {myRow.rank > 1
              ? `${data[myRow.rank - 2]?.weekly_xp - myRow.weekly_xp} XP to reach rank #${myRow.rank - 1}`
              : '🏆 You are leading this week!'}
          </div>
        </div>
      )}

      <div className="section-label">All Rankings — Week {new Date().getWeekNumber?.() || ''}</div>

      <div className="card">
        {data.length === 0 && (
          <div style={{ color: 'var(--text3)', textAlign: 'center', padding: '20px 0', fontSize: 13 }}>
            No updates this week yet. Be the first! 🚀
          </div>
        )}
        {data.map((row, i) => (
          <div key={row.user_name} className="lb-row" style={{
            background: row.user_name === user.name ? 'rgba(201,168,76,0.05)' : 'transparent',
            margin: '0 -16px', padding: '10px 16px'
          }}>
            <div className={`lb-rank ${i < 3 ? 'gold' : ''}`} style={{ fontSize: i < 3 ? 20 : 16, color: i === 0 ? 'var(--gold)' : 'var(--text3)' }}>
              {i < 3 ? medals[i] : i + 1}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: row.user_name === user.name ? 600 : 400 }}>
                {row.user_name} {row.user_name === user.name ? '← You' : ''}
              </div>
              <div className="lb-meta">
                🔥 {row.current_streak} days · {row.updates_this_week} updates this week
              </div>
            </div>
            <div className="lb-xp">
              <div className="lb-xp-num" style={{ color: i === 0 ? 'var(--gold)' : 'var(--text3)' }}>{row.weekly_xp}</div>
              <div className="lb-xp-lbl">XP</div>
            </div>
          </div>
        ))}
      </div>

      {/* XP Guide */}
      <div className="card" style={{ margin: '8px 16px 16px' }}>
        <div className="card-title">How XP Works</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 12, color: 'var(--text3)' }}>
          <div>🎯 Update on time → <span style={{ color: 'var(--gold)' }}>+10 XP</span></div>
          <div>⚡ Update 1–3 days late → <span style={{ color: 'var(--gold)' }}>+7 XP</span></div>
          <div>📝 Add a remark → <span style={{ color: 'var(--gold)' }}>+3 XP bonus</span></div>
          <div>🔥 Daily streak multiplier → <span style={{ color: 'var(--gold)' }}>up to 2×</span></div>
        </div>
      </div>
    </div>
  );
}
